import { resolveUploadsUrl } from '@/lib/resolve-uploads-url';

/** Couverture par défaut des podcasts sans image (fichier public Vite). */
export const DEFAULT_PODCAST_COVER_PATH = '/PreviewPodcast.png';

/** URL affichable pour une couverture podcast (uploads ou défaut LyrraOne). */
export function resolvePodcastCoverUrl(coverImageUrl?: string | null): string {
  const raw = coverImageUrl?.trim();
  if (!raw) return DEFAULT_PODCAST_COVER_PATH;
  return resolveUploadsUrl(raw) ?? raw;
}

export function hasCustomPodcastCover(coverImageUrl?: string | null): boolean {
  return Boolean(coverImageUrl?.trim());
}

/** Couverture épisode : image épisode si définie, sinon couverture podcast (avec défaut). */
export function resolveEpisodeCoverDisplayUrl(
  episodeCoverUrl?: string | null,
  podcastCoverUrl?: string | null,
): string {
  const ep = episodeCoverUrl?.trim();
  if (ep) return resolveUploadsUrl(ep) ?? ep;
  return resolvePodcastCoverUrl(podcastCoverUrl);
}
